import { CmsProtectionCardBanner } from '../../models/cms/cms-protection-card-banner.interface';

export const mockCmsProtectionCardBanner: CmsProtectionCardBanner = {
  protectionCardBannerPlan: 'Your Plan Details',
  protectionCardBannerRegistration: 'Registration confirmed',
};
